module.exports = __webpack_public_path__ + "img/123.789c4e49.jpg";